import {createContext, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {
	checkAuthorization,
	apiError,
	handleRequest
} from "~/utils";
import {Loading} from "../components";
import {useViewport} from "~/hooks";
import {authApi, utilsApi} from "../api";
import {authActions} from "../reduxs/Auth/authSlice";
import productSyncService from "../services/productSyncService";

const AppContext = createContext(undefined);

// APP GLOBAL DATA
function AppProvider({ children }) {

	const dispatch = useDispatch();

	const [loading, setLoading] = useState(true);

	const [loginAsUsers, setLoginAsUsers] = useState([]);

	const [rolesData, setRolesData] = useState([]);

	const [permissions, setPermissions] = useState([]);

	const [appData, setAppData] = useState([]);

	const [userLogin, setUserLogin] = useState(false);

	const [tableHeight, setTableHeight] = useState('60vh');

	useEffect(() => {
		if(checkAuthorization()) {
			(async () => {

				let [errorUser, responseUser] = await handleRequest(authApi.current());

				let messageUser = apiError(`Lấy thông tin tài khoản thất bại`, errorUser, responseUser);

				if (!messageUser && responseUser.data?.user)
				{
					setPermissions(responseUser.data.permission);

					dispatch(authActions.loginSuccess(responseUser.data?.user));

					/* Các Thông tin khác */
					let utilitiesDataKey = localStorage.getItem('utilities-key');

					if (responseUser.data.utilitiesKey !== utilitiesDataKey)
					{
						let [error, response] = await handleRequest(utilsApi.gets());

						if (!apiError(`Load thông tin thất bại`, error, response))
						{
							localStorage.setItem('utilities-key', responseUser.data?.utilitiesKey);
							localStorage.setItem('rolesData', JSON.stringify(response.data?.roles));
							localStorage.setItem('appData', JSON.stringify(response.data?.data));
							setAppData(response.data?.data);
							setRolesData(response.data?.roles);
						}
					}
					else
					{
						setAppData(JSON.parse(localStorage.getItem('appData')));
						setRolesData(JSON.parse(localStorage.getItem('rolesData')));
					}

					/* Product Sync Check */
					const serverSyncVersion = responseUser.data?.syncProductVersion;

					if (serverSyncVersion)
					{
						try
						{
							const needSync = await productSyncService.checkSyncNeeded(serverSyncVersion);

							if (needSync)
							{
								const syncResult = await productSyncService.syncProducts();

								if (!syncResult.success)
								{
									console.error('❌ Product sync failed:', syncResult.message);
								}
							}
						}
						catch (error)
						{
							console.error('❌ Product sync error:', error);
						}
					}
				}
				else
				{
					localStorage.clear();
					dispatch(authActions.logout());
				}
				setLoading(false);
			})();
		}
		else {
			setLoading(false);
		}
	}, [userLogin]);

	// Handle responsive
	const viewport = useViewport();
	const [isMobile, setIsMobile] = useState(false);
	const [isTablet, setIsTablet] = useState(false);
	const [isDesktop, setIsDesktop] = useState(false);

	useEffect(() => {
		if (viewport.width < 768) {
			setIsMobile(true);
			setIsTablet(false);
			setIsDesktop(false);
			setTableHeight('60vh');
		}
		else if (viewport.width < 1300) {
			setIsMobile(false);
			setIsTablet(true);
			setIsDesktop(false);
			setTableHeight('50vh');
		}
		else {
			setIsMobile(false);
			setIsTablet(false);
			setIsDesktop(true);
			setTableHeight('60vh');
		}
	}, [viewport.width]);

	if (loading) return <Loading />

	return (
		<AppContext.Provider value={{
			isMobile,
			isDesktop,
			isTablet,
			loginAsUsers,
			setLoginAsUsers,
			userLogin,
			setUserLogin,
			tableHeight,
			rolesData,
			appData,
			permissions,
		}}>
			{children}
		</AppContext.Provider>
	)
}

export { AppContext };
export default AppProvider;